import VueDatepicker from '@vuepic/vue-datepicker';
import VueDatepickerActionRow from '@/components/VueDatepickerActionRow/index.vue';
import '@vuepic/vue-datepicker/dist/main.css';
const componentName = 'vueDatepicker';
export const componentGlobalConfig = {
    locale: 'ko',
    // format https://date-fns.org/v2.16.1/docs/format
    format: 'yyyy-MM-dd',
    selectText: '선택',
    cancelText: '취소',
    weekStart: 0,
    // 초기화 아이콘 기본값: 끄기
    clearable: false,
    // 시간 설정 기본값: 끄기
    enableTimePicker: false,
    teleport: true,
    // css block을 주고 싶을 땐 class="block"을 넘기면 된다.
    block: false,
    // VueDatepickerActionRow 에서 날짜를 숨긴다
    hideDate: false,
    // 확인 버튼만 있어야할 경우 (날짜 클릭으로 이벤트 발동 케이스에 적합)
    closeBtnOnly: false,
    config: {
        // https://github.com/Vuepic/vue-datepicker/issues/956
        shadowDom: true,
    },
};
export default {
    install(app, options = {}) {
        const props = {
            ...VueDatepicker.props,
        };
        Object.keys(options).forEach((k) => {
            props[k] = {
                default: options[k],
            };
        });
        app
            .component(componentName, {
            ...VueDatepicker,
            props,
        })
            .component('vueDatepickerActionRow', VueDatepickerActionRow);
    },
};
